import { adminErrorsAdapter, ErrorsPage, type ErrorsSearch } from '@pa/staff'
import { useMemo } from 'react'

/**
 * S-04 Errors tab (UserFlows S-04: "the same content as C-03 / C-03a, for this clinic"): the shared `errors` feature
 * over the admin adapter with `?clinicId=` (#61–#63, Frontend §7.2). Date presets and times in the clinic's zone.
 */
export function ErrorsTab({
  clinicId,
  timeZone,
  search,
  onSearch,
}: {
  clinicId: string
  timeZone: string
  search: ErrorsSearch
  onSearch: (next: ErrorsSearch, opts?: { replace?: boolean }) => void
}) {
  const adapter = useMemo(() => adminErrorsAdapter(clinicId), [clinicId])
  return <ErrorsPage adapter={adapter} timeZone={timeZone} search={search} onSearch={onSearch} layout="tab" />
}
